import { SelectionChangedEvent } from "ag-grid-community";
import { EmptyPoolExclCriteriaEntity } from "domain/entity/EmptyPoolExclusion/EmptyPoolExclCriteriaEntity";
import { INITIAL_EMPTY_POOL_EXCL_COMP_COL_DEF, INITIAL_EMPTY_POOL_EXCL_COMP_COL_DEF_OICT, transferRowData } from "presentation/constant/EmptyPoolExclusion/EmptyPoolExclComponentColumnDefinition";
import { EmptyPoolExclusionConstant } from "presentation/constant/EmptyPoolExclusion/EmptyPoolExclusionConstant";
import { useEmptyPoolExclusionCriteriaVM } from "presentation/hook/EmptyPoolExclusionCriteria/useEmptyPoolExclusionCriteriaVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useEmptyExclCriteriaTracked } from "presentation/store/EmptyPoolExclusionCriteria/EmptyPoolExclusionCriteriaProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";

const EmptyPoolExclusionCriteriaComponentTablePanel: React.FC = () => {
    const [criteriaState] = useEmptyExclCriteriaTracked();
    const criteriaVM = useEmptyPoolExclusionCriteriaVM();
    const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);
    const [anaInfoState] = useANAInfoTracked();
    const { allowCreate, operatingUnit } = anaInfoState;

    let gridRef: any = useRef();

    useEffect(() => {
        if (!onTableSelectionClicked) return;

        gridRef.current?.gridRef.current.api?.deselectAll();
    }, [onTableSelectionClicked])

    useEffect(() => {
        // const columnDefs = (INITIAL_EMPTY_POOL_EXCL_COMP_COL_DEF?.slice());

        //gridRef.current?.gridRef.current.api?.setColumnDefs(columnDefs);
        if (!onTableSelectionClicked) {
            gridRef.current?.gridRef.current.api?.deselectAll();
        }
    })

    const handleRowDoubleClick = useCallback((consGrpComp: EmptyPoolExclCriteriaEntity) => {
        criteriaVM.onRowDoubleClick(consGrpComp);
    }, [criteriaVM])


    const handleAddClick = useCallback(async () => {
        criteriaVM.onAdd();
    }, [criteriaVM])

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        setOnTableSelectionClicked(true);
        const selectedRows = e.api.getSelectedRows();
        criteriaVM.updateSelectedComponentRows(selectedRows);
    }, [criteriaVM])

    const memoCriteriaComponentTable = useMemo(() => {
        return <NbisTable
            id='CriteriaComponent-table'
            headerLabel={EmptyPoolExclusionConstant.Title.EMPTY_POOL_EXCLUSION_MAIN}
            columns={(operatingUnit !== 'SAPT' && operatingUnit !== 'KICT') ? INITIAL_EMPTY_POOL_EXCL_COMP_COL_DEF_OICT?.slice() : INITIAL_EMPTY_POOL_EXCL_COMP_COL_DEF?.slice()}
            data={transferRowData(criteriaState.criteriaEntityList ?? [])}
            showPaginator={false}
            editable={false}
            showAddIcon={allowCreate && !criteriaState.masterState.isSliderOpen}
            showDeleteButton={false}
            showReloadIcon={false}
            isScrollHighlighted={true}
            selectionMode={false}
            //rowSelection={"multiple"}
            isRowHighligted={true}
            isNewColumnSetting={true}
            onAddClick={handleAddClick}
            handleSelectionChanged={handleSelectionChange}
            onRowDoubleClick={(e: any) => handleRowDoubleClick(e.data)}
            gridHeight="customHeight"
            customHeight="calc(100vh - 75px)"
            ref={gridRef} />;
    }, [operatingUnit, criteriaState.criteriaEntityList, criteriaState.masterState.isSliderOpen, allowCreate, handleAddClick, handleSelectionChange, handleRowDoubleClick])

    return <>
        {<TableWrapper>{memoCriteriaComponentTable}</TableWrapper>}
    </>;
}

export default memo(EmptyPoolExclusionCriteriaComponentTablePanel);